import GameWeek from '@/models/GameWeek/gameWeek';
import Lineup from '@/models/Lineup/lineup';
import User from '@/models/User/user';
import consts from '@/consts.js'

export default class UserMegaLeague {
  constructor({
    gameWeek = new GameWeek(),
    user = new User(),
    lineup = null,
    totalScore = 0,
    usersCount = 0,
  } = {}) {
    this.gameWeek = gameWeek ? GameWeek.createFromObject(gameWeek) : null;
    this.user = user ? User.createFromObject(user) : null;
    this.lineup = lineup ? Lineup.createFromObject(lineup) : new Lineup();
    this.usersCount = usersCount
    this.totalScore = totalScore;
  }

  maxScore() {
    return consts.MEGA_LEAGUE.PLAYER_COUNT * 100;
  }

  increaseUserCount() {
    this.usersCount += 1;
  }

  decreaseUserCount() {
    this.usersCount -= 1;
  }

  static createFromObject(data) {
    return new UserMegaLeague(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (userMegaLeagueData) => UserMegaLeague.createFromObject(userMegaLeagueData),
    );
  }
}
